"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = exports.Address = void 0;
class Address {
    constructor(value) {
        this.value = value;
    }
    bech32() {
        return this.value;
    }
}
exports.Address = Address;
class Signature {
    constructor(value) {
        this.value = value;
    }
    hex() {
        return this.value;
    }
}
exports.Signature = Signature;
//# sourceMappingURL=primitives.js.map